import { IBaseModel, BaseModel } from '../base.model';

export interface IBMContractorEditedViewModel extends IBaseModel {
  date_end_work?: string,
  date_start_work?: string,
  fk_entity_contractor: number,
  progress?: string
}
export class BMContractorEditedViewModel extends BaseModel implements IBMContractorEditedViewModel {
  date_end_work?: string
  date_start_work?: string
  fk_entity_contractor: number
  progress?: string

  constructor (date_end_work: string = null,
               date_start_work: string = null,
               fk_entity_contractor: number = null,
               progress: string = '0%') {
    super()
    this.date_end_work = date_end_work
    this.date_start_work = date_start_work
    this.fk_entity_contractor = fk_entity_contractor
    this.progress = progress
  }
}



// WEBPACK FOOTER //
// ./src/models/bm/bm-contractor-edited.viewmodel.ts